<template>
	<div class="bg">
		<div class="search-container">
			<div style="font-size: 16px; font-weight: bold; padding-bottom: 16px;">商品数据</div>

			<!-- 筛选区域 -->
			<div class="search-form">
				<div class="input-wrapper">
					<label class="input-label">时间维度：</label>
					<el-radio-group v-model="searchParams.timeDimension" @change="handleTimeDimensionChange">
						<el-radio :label="1">日</el-radio>
						<el-radio :label="2">月</el-radio>
						<el-radio :label="3">年</el-radio>
					</el-radio-group>
				</div>
				<div class="input-wrapper">
					<label class="input-label">查询日期：</label>
					<el-date-picker v-model="searchParams.queryDate" :type="datePickerType" :value-format="datePickerValueFormat"
						:placeholder="datePickerPlaceholder" clearable style="width: 100%; background-color: #F2F3F5;">
					</el-date-picker>
				</div>

				<div class="divider"></div>
				<div class="search flexc" style="cursor: pointer;" @click="handleSearch">
					<img src="/images/goodsList/search.svg" width="14px" height="14px" alt="" />
					<div style="margin-left: 4px; font-size: 14px;">查询</div>
				</div>
				<div class="reset flexc" style="cursor: pointer;" @click="handleReset">
					<div style="margin-left: 4px; font-size: 14px;">重置</div>
				</div>
			</div>
		</div>

		<div style="margin-top: 20px;">
			<el-table ref="etb2" class="custom-header-table" :height="tblHeight" v-loading="tableLoading"
				:data="tableData">
				<el-table-column type="index" label="序号" width="70" align="center" :index="getTableIndex">
				</el-table-column>
				<el-table-column label="日期" width="140" align="center">
					<template slot-scope="scope">
						<div class="price">{{ scope.row.dataTime || '--' }}</div>
					</template>
				</el-table-column>
				<el-table-column label="商品类别" min-width="160" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<div class="ellipsis">{{ scope.row.customizeLabelName || '--' }}</div>
					</template>
				</el-table-column>
				<el-table-column label="商品名称" min-width="200" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<div class="ellipsis">{{ scope.row.goodsName || '--' }}</div>
					</template>
				</el-table-column>
				<el-table-column label="浏览量（次）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatValue(scope.row.browseCount) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="订单量（单）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatValue(scope.row.orderNum) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="订单总额（元）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatAmount(scope.row.orderAmount) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="取消订单量（单）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatValue(scope.row.refundOrderNum) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="取消订单总额（元）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatAmount(scope.row.refundOrderAmount) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="到店订单量（单）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatValue(scope.row.onSiteNum) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="到店订单额（元）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatAmount(scope.row.onSiteAmount) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="配送订单量（单）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatValue(scope.row.takeoutNum) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="配送订单额（元）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatAmount(scope.row.takeoutAmount) }}</div>
					</template>
				</el-table-column>
			</el-table>

			<div style="margin-top: 12px;display: flex;align-items: center; justify-content: space-between;">
				<div class="flexs">
					<div class="down flexc" style="margin-left: 20px; cursor: pointer;" @click="handleExport">
						<i class="el-icon-folder-add" style="padding-right: 4px;"></i>
						导出
					</div>
				</div>
				<div class="flexe" style="margin-top: 12px;">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]"
						:page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" background>
					</el-pagination>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		operationStatisticApi
	} from '@/api';
	import {
		exportTableToExcel
	} from '@/utils/exportExcel';

	export default {
		name: 'GoodsDate',
		data() {
			return {
				tableLoading: false,
				exportLoading: false,
				tblHeight: null,
				searchParams: {
					timeDimension: 1,
					queryDate: ''
				},
				pagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				tableData: []
			};
		},
		created() {
			this.fetchList();
		},
		computed: {
			datePickerType() {
				return this.searchParams.timeDimension === 1 ? 'month' : 'year';
			},
			datePickerValueFormat() {
				return this.searchParams.timeDimension === 1 ? 'yyyy-MM' : 'yyyy';
			},
			datePickerPlaceholder() {
				return this.searchParams.timeDimension === 1 ? '请选择月份' : '请选择年份';
			}
		},
		methods: {
			handleTimeDimensionChange() {
				this.searchParams.queryDate = '';
			},
			formatQueryDateForRequest() {
				const {
					timeDimension,
					queryDate
				} = this.searchParams;
				if (!queryDate) {
					return '';
				}
				if (timeDimension === 1 && /^\d{4}-\d{2}$/.test(queryDate)) {
					return `${queryDate}-01`;
				}
				if ((timeDimension === 2 || timeDimension === 3) && /^\d{4}$/.test(queryDate)) {
					return `${queryDate}-01-01`;
				}
				return queryDate;
			},
			getStoreId() {
				return this.$store.getters['auth/storeId'];
			},
			buildRequestParams(pageNo, pageSize) {
				const params = {
					pageNo: pageNo,
					pageSize: pageSize,
					timeDimension: this.searchParams.timeDimension
				};
				const queryDate = this.formatQueryDateForRequest();
				if (queryDate) {
					params.queryDate = queryDate;
				}
				const storeId = this.getStoreId();
				if (storeId) {
					params.storeId = storeId;
				}
				return params;
			},
			async fetchList() {
				this.tableLoading = true;
				try {
					const response = await operationStatisticApi.goodsList(this.buildRequestParams(this.pagination.currentPage, this.pagination.pageSize));
					if ((response.code === 0 || response.code === 200) && response.data) {
						const list = response.data.list || [];
						this.tableData = Array.isArray(list) ? list : [];
						this.pagination.total = response.data.total || 0;

						// 如果没有数据且不是第一页，则自动跳转到上一页
						if (this.tableData.length === 0 && this.pagination.currentPage > 1) {
							this.pagination.currentPage -= 1;
							this.fetchList();
							return;
						}
					} else {
						this.tableData = [];
						this.pagination.total = 0;
						this.$message.error(response.msg || '获取商品数据失败');
					}
				} catch (err) {
					console.error('获取商品数据错误:', err);
					this.tableData = [];
					this.pagination.total = 0;
					this.$message.error('网络异常，无法获取商品数据');
				} finally {
					this.tableLoading = false;
				}
			},
			handleSearch() {
				this.pagination.currentPage = 1;
				this.fetchList();
			},
			handleReset() {
				this.searchParams = {
					timeDimension: 1,
					queryDate: ''
				};
				this.pagination.currentPage = 1;
				this.fetchList();
			},
			handleSizeChange(pageSize) {
				this.pagination.pageSize = pageSize;
				this.pagination.currentPage = 1;
				this.fetchList();
			},
			handleCurrentChange(currentPage) {
				this.pagination.currentPage = currentPage;
				this.fetchList();
			},
			getTableIndex(index) {
				return (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1;
			},
			formatValue(value) {
				if (value === 0) {
					return 0;
				}
				return value || '--';
			},
			formatAmount(value) {
				if (value === 0) {
					return 0;
				}
				if (value === null || value === undefined || value === '') {
					return '--';
				}
				return value;
			},
			async handleExport() {
				if (this.exportLoading) {
					return;
				}
				this.exportLoading = true;
				try {
					const pageSize = 100;
					const firstRes = await operationStatisticApi.goodsList(this.buildRequestParams(1, pageSize));
					if (!((firstRes.code === 0 || firstRes.code === 200) && firstRes.data)) {
						this.$message.error(firstRes.msg || '导出失败');
						return;
					}

					const firstList = Array.isArray(firstRes.data.list) ? firstRes.data.list : [];
					const total = firstRes.data.total || firstList.length;
					const pageCount = Math.ceil(total / pageSize) || 1;

					let all = firstList.slice();
					for (let i = 2; i <= pageCount; i++) {
						const res = await operationStatisticApi.goodsList(this.buildRequestParams(i, pageSize));
						if (!((res.code === 0 || res.code === 200) && res.data)) {
							break;
						}
						const list = Array.isArray(res.data.list) ? res.data.list : [];
						all = all.concat(list);
					}

					const columns = [{
							label: '序号',
							prop: '__index'
						},
						{
							label: '日期',
							prop: 'dataTime'
						},
						{
							label: '商品类别',
							prop: 'customizeLabelName'
						},
						{
							label: '商品名称',
							prop: 'goodsName'
						},
						{
							label: '浏览量（次）',
							prop: 'browseCount'
						},
						{
							label: '订单量（单）',
							prop: 'orderNum'
						},
						{
							label: '订单总额（元）',
							prop: 'orderAmount'
						},
						{
							label: '取消订单量（单）',
							prop: 'refundOrderNum'
						},
						{
							label: '取消订单总额（元）',
							prop: 'refundOrderAmount'
						},
						{
							label: '到店订单量（单）',
							prop: 'onSiteNum'
						},
						{
							label: '到店订单额（元）',
							prop: 'onSiteAmount'
						},
						{
							label: '配送订单量（单）',
							prop: 'takeoutNum'
						},
						{
							label: '配送订单额（元）',
							prop: 'takeoutAmount'
						}
					];

					const rows = (all || []).map((item, idx) => ({
						...item,
						__index: idx + 1
					}));

					exportTableToExcel({
						fileName: '商品数据.xls',
						columns,
						rows
					});
				} catch (err) {
					console.error('导出商品数据失败:', err);
					this.$message.error('导出失败，请重试');
				} finally {
					this.exportLoading = false;
				}
			}
		}
	};
</script>
